<script setup lang="ts">
const contentStore = useContentStore();
const { landingPageContents } = classToRefs(contentStore);
</script>
<template>
    <div v-if="landingPageContents?.cityCards?.length" class="container">
        <mr-typography
            v-if="landingPageContents?.cityCardsTitle"
            type="h2"
            size="large"
            weight="900"
            color="var(--gray-900)"
        >
            {{ landingPageContents?.cityCardsTitle }}
        </mr-typography>
        <div class="plane-tickets-container">
            <mr-typography
                v-for="ticket in landingPageContents.cityCards"
                :key="ticket.id"
                type="a"
                size="x-small"
                align="center"
                color="white"
                class="caption plane-ticket-link"
                :style="{ '--url': `url(${ticket.image})` }"
                :href="ticket.link"
            >
                {{ ticket.cityTitle }}
            </mr-typography>
        </div>
    </div>
</template>
<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-block: 16px;
    @include mobile-only(1232px) {
        padding-inline: 16px;
        margin-inline: 0 !important;
    }
    .plane-tickets-container {
        display: flex;
        justify-content: flex-start;
        text-align: right;
        flex-wrap: wrap;
        width: 100%;
        gap: 16px;
        @include no-scrollbar;
        @include mobile-only {
            border-right: none;
            border-bottom: 3px solid usePalette($p-cool-gray, $p-100);
            overflow: auto;
            flex-wrap: nowrap;
            padding: 0;
        }

        &:last-child {
            border-bottom: none;
        }

        .plane-ticket-link {
            border-radius: 16px;
            overflow: hidden;
            flex-shrink: 0;
            width: 136px;
            height: 194px;
            padding-bottom: 24px;
            padding-top: 150px;
            background: linear-gradient(
                    180deg,
                    rgba($color: usePalette($p-blue, $p-500), $alpha: 0) 46.35%,
                    usePalette($p-blue, $p-200) 100%
                ),
                var(--url);
        }
    }
}
</style>
